import { Chart } from '@devexpress/dx-react-chart';
import { withClassName } from './utils';

export const Root = withClassName('dx-c-bs4-container')(Chart.Root);
